(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["1849-browse-return"] && !Shopify.designMode) return;
  try {
    (() => {
    const config = document.getElementById('mercantile-browse-config');
    if (!config || window.mercantileBrowseReturnInitialized) return;
    window.mercantileBrowseReturnInitialized = true;

    const storageKey = '1849:browse-return:v1';
    const stateKey = '__mercantileBrowseV1';
    const ttl = 30 * 60 * 1000;
    const intentTtl = 15 * 1000;
    const isBrowsePage = ['index', 'collection', 'list-collections', 'search'].includes(config.dataset.pageType);
    let activeTrip = null;
    let initialBackEligible = false;
    let restorationController = null;

    function safeURL(value) {
      try {
        if (typeof value !== 'string' || value.length === 0) return null;
        const url = new URL(value, location.origin);
        if (url.origin !== location.origin || !['http:', 'https:'].includes(url.protocol) || url.username || url.password) return null;
        return url;
      } catch {
        return null;
      }
    }

    function sameDocument(first, second) {
      const a = safeURL(first);
      const b = safeURL(second);
      return Boolean(a && b && a.pathname === b.pathname && a.search === b.search);
    }

    function isProductURL(value) {
      const url = safeURL(value);
      return Boolean(url && /\/products\/[^/]+\/?$/.test(url.pathname));
    }

    function isBrowseURL(value) {
      const url = safeURL(value);
      const root = safeURL(config.dataset.rootUrl);
      return Boolean(url && !isProductURL(url.href) && ((root && url.pathname === root.pathname) || /\/collections(?:\/[^/]+)?\/?$/.test(url.pathname) || /\/search\/?$/.test(url.pathname)));
    }

    function validTrip(trip) {
      return Boolean(trip && typeof trip.id === 'string' && Number.isFinite(trip.at) && Date.now() - trip.at >= 0 && Date.now() - trip.at < ttl && isBrowseURL(trip.source) && isProductURL(trip.destination) && Number.isFinite(trip.x) && Number.isFinite(trip.y) && Array.isArray(trip.rails));
    }

    function readStore() {
      try {
        const value = JSON.parse(sessionStorage.getItem(storageKey) || '{}');
        return {
          trips: Array.isArray(value.trips) ? value.trips.filter(validTrip).slice(-8) : [],
          pending: typeof value.pending === 'string' ? value.pending : null,
          intent: value.intent && Number.isFinite(value.intent.at) && Date.now() - value.intent.at >= 0 && Date.now() - value.intent.at < intentTtl ? value.intent : null
        };
      } catch {
        return { trips: [], pending: null, intent: null };
      }
    }

    function writeStore(value) {
      try {
        sessionStorage.setItem(storageKey, JSON.stringify(value));
        return true;
      } catch {
        return false;
      }
    }

    function token() {
      return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
    }

    function stateMarker() {
      return history.state && typeof history.state === 'object' ? history.state[stateKey] : null;
    }

    function markState(marker) {
      try {
        if (history.state !== null && (typeof history.state !== 'object' || Array.isArray(history.state))) return false;
        history.replaceState({ ...(history.state || {}), [stateKey]: marker }, '', location.href);
        return true;
      } catch {
        return false;
      }
    }

    function navigationType() {
      return performance.getEntriesByType('navigation')[0]?.type || '';
    }

    function capturePosition(trip) {
      trip.x = window.scrollX;
      trip.y = window.scrollY;
      trip.rails = Array.from(document.querySelectorAll('scroll-carousel[id]')).slice(0, 12).map((rail) => ({
        id: rail.id,
        x: rail.scrollLeft,
        y: rail.scrollTop
      }));
      return trip;
    }

    function plainClick(event, link) {
      return !event.defaultPrevented && event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && !link.hasAttribute('download') && (!link.target || link.target === '_self');
    }

    function rememberProductClick(event) {
      const link = event.target.closest?.('a[href]');
      if (!isBrowsePage || !link || !plainClick(event, link) || !isBrowseURL(location.href) || !isProductURL(link.href)) return;
      const trip = capturePosition({ id: token(), at: Date.now(), source: location.href, destination: link.href, sourceEntry: token(), visited: false });
      const sourceSection = link.closest?.('[id^="shopify-section-"]');
      if (sourceSection?.id) {
        const matchingLinks = Array.from(sourceSection.querySelectorAll('a[href]')).filter((item) => item.href === link.href);
        trip.focusLink = { section: sourceSection.id, index: matchingLinks.indexOf(link) };
      }
      if (!markState({ role: 'browse', trip: trip.id, entry: trip.sourceEntry })) return;
      const store = readStore();
      store.trips = [...store.trips, trip].slice(-8);
      store.pending = trip.id;
      store.intent = null;
      writeStore(store);
    }

    function configureProductReturn() {
      if (config.dataset.pageType !== 'product') return;
      const store = readStore();
      const marker = stateMarker();
      let trip = marker?.role === 'product' ? store.trips.find((item) => item.id === marker.trip && item.productEntry === marker.entry) : null;
      if (trip && safeURL(trip.destination)?.pathname !== location.pathname) trip = null;

      if (!trip) {
        const pending = store.trips.find((item) => item.id === store.pending);
        if (pending && sameDocument(pending.destination, location.href) && sameDocument(pending.source, document.referrer) && navigationType() === 'navigate') {
          trip = pending;
          trip.productEntry = token();
          trip.productURL = location.href;
          trip.productHistoryLength = history.length;
          trip.visited = true;
          initialBackEligible = markState({ role: 'product', trip: trip.id, entry: trip.productEntry });
        }
      }

      store.pending = null;
      if (trip?.visited) trip.returnPending = true;
      writeStore(store);
      if (!validTrip(trip) || !trip.visited) return;
      activeTrip = trip;
      document.querySelectorAll('[data-mercantile-browse-return]').forEach((link) => {
        link.href = trip.source;
        const text = link.querySelector('[data-mercantile-return-text]');
        if (text) text.textContent = link.dataset.returnLabel;
      });
    }

    function previousEntryIsSource(trip) {
      try {
        if (window.navigation?.entries && window.navigation.currentEntry) {
          const currentIndex = window.navigation.currentEntry.index;
          const previous = window.navigation.entries().find((entry) => entry.index === currentIndex - 1);
          if (previous) return safeURL(previous.url)?.href === safeURL(trip.source)?.href;
          return false;
        }
      } catch {
        return false;
      }
      const marker = stateMarker();
      return initialBackEligible && history.length === trip.productHistoryLength && history.length > 1 && location.href === trip.productURL && marker?.role === 'product' && marker.trip === trip.id && marker.entry === trip.productEntry && sameDocument(document.referrer, trip.source);
    }

    function returnToBrowsing(event) {
      const link = event.target.closest?.('[data-mercantile-browse-return]');
      if (!link || !plainClick(event, link) || !validTrip(activeTrip)) return;
      const store = readStore();
      const trip = store.trips.find((item) => item.id === activeTrip.id && item.visited);
      if (!trip || safeURL(link.href)?.href !== safeURL(trip.source)?.href) return;
      store.intent = { trip: trip.id, at: Date.now(), from: location.href };
      if (!writeStore(store)) return;
      if (previousEntryIsSource(trip)) {
        event.preventDefault();
        history.back();
      }
    }

    function restorePosition(trip, focusSource) {
      restorationController?.abort();
      const controller = new AbortController();
      restorationController = controller;
      const cancel = () => controller.abort();
      ['pointerdown', 'wheel', 'touchstart', 'keydown'].forEach((name) => {
        window.addEventListener(name, cancel, { once: true, passive: true, signal: controller.signal });
      });
      const apply = () => {
        if (controller.signal.aborted || location.href !== trip.source) return;
        trip.rails.forEach((saved) => {
          if (typeof saved.id !== 'string' || !Number.isFinite(saved.x) || !Number.isFinite(saved.y)) return;
          const rail = document.getElementById(saved.id);
          if (rail?.matches('scroll-carousel')) rail.scrollTo({ left: saved.x, top: saved.y, behavior: 'instant' });
        });
        window.scrollTo({ left: trip.x, top: trip.y, behavior: 'instant' });
      };
      requestAnimationFrame(() => requestAnimationFrame(apply));
      setTimeout(apply, 200);
      setTimeout(() => {
        apply();
        if (!controller.signal.aborted && focusSource) {
          const savedFocus = trip.focusLink;
          if (savedFocus && typeof savedFocus.section === 'string' && Number.isInteger(savedFocus.index) && savedFocus.index >= 0) {
            const sourceSection = document.getElementById(savedFocus.section);
            const matchingLinks = sourceSection ? Array.from(sourceSection.querySelectorAll('a[href]')).filter((link) => link.href === trip.destination) : [];
            matchingLinks[savedFocus.index]?.focus({ preventScroll: true });
          }
        }
        controller.abort();
      }, 600);
    }

    function handlePageShow(event) {
      if (config.dataset.pageType === 'product') {
        configureProductReturn();
        return;
      }
      if (!isBrowsePage || !isBrowseURL(location.href)) return;
      const store = readStore();
      const marker = stateMarker();
      const explicit = store.intent && isProductURL(store.intent.from) ? store.trips.find((trip) => trip.id === store.intent.trip && trip.source === location.href && trip.visited) : null;
      const traversed = event.persisted || navigationType() === 'back_forward';
      const returned = traversed && marker?.role === 'browse' ? store.trips.find((trip) => trip.id === marker.trip && trip.sourceEntry === marker.entry && trip.source === location.href && trip.visited && trip.returnPending) : null;
      const trip = explicit || returned;
      if (!trip) return;
      store.intent = null;
      trip.returnPending = false;
      writeStore(store);
      restorePosition(trip, Boolean(explicit));
    }

    document.addEventListener('click', returnToBrowsing);
    document.addEventListener('click', rememberProductClick);
    window.addEventListener('pagehide', () => {
      restorationController?.abort();
      if (!isBrowsePage) return;
      const store = readStore();
      const marker = stateMarker();
      const trip = store.trips.find((item) => item.id === marker?.trip && item.source === location.href);
      if (trip) {
        capturePosition(trip);
        writeStore(store);
      }
    });
    window.addEventListener('pageshow', handlePageShow);
    if (document.readyState === 'complete') handlePageShow({ persisted: false });
  })();
  } catch(e) { console.error(e); }
})();

})();
